<template>
    <v-navigation-drawer
        v-model="drawerLocal"
        :clipped="true"
        :absolute="false"
        app
        style="border-right: 1px solid"
        @input="updateDrawer"
    >
        <sidebar-menu />
    </v-navigation-drawer>
</template>

<script>
import SidebarMenu from "@/components/Menu/SidebarMenu.vue";

export default {
    name: "AppSidebar",
    components: {
        SidebarMenu
    },
    props: {
        drawer: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        drawerLocal: false
    }),
    watch: {
        drawer: {
            immediate: true,
            handler(val) {
                this.drawerLocal = val;
            }
        }
    },
    methods: {
        updateDrawer(value) {
            this.$emit('update:drawer', value);
        }
    }
};
</script> 